import { getRequest } from '../services/requestHandler';
import { HeadModelHandForDropdownDto } from '../models';

export const getHeadModelHandsForDropdown = async () => {
  const url = 'head/getHeadModelHandsForDropdown?useCache=true';
  const response = await getRequest<HeadModelHandForDropdownDto>('getHeadModelHandsForDropdown', url);
  return response;
};
